import React, { useContext, useState, useEffect } from "react"
import { ConfigContext, QuizzContext } from "@bit/dweez.perso.quizz.contexts"
import Quizz from "@bit/dweez.perso.quizz.quizz"
import QuizzViewer from "@bit/dweez.perso.quizz.viewer"
import Stepper from "@bit/dweez.perso.quizz.stepper"

import { css } from "theme-ui"

import { TransitionGroup, CSSTransition } from "react-transition-group"
import "./loader.css"
import "./viewer.css"

const QuizzLoader = props => {
  const [config] = useContext(ConfigContext)
  const [state] = useContext(QuizzContext)
  const [isLoaded, setIsLoaded] = useState(false)
  const [previous, setPrevious] = useState(false)
  const [heightQuizz, setHeightQuizz] = useState(false)

  useEffect(() => {
    setIsLoaded(!(previous !== state.currentQuestion.id))
    setPrevious(state.currentQuestion.id)
  }, [state.currentQuestion, previous])

  useEffect(() => {
    // setHeightQuizz(!state.completed ? "285px" : 0)
    setHeightQuizz(!state.completed ? "396px" : 0)
  }, [state.completed])

  return (
    <>
      <div className="header-quizz">
        {config.questionnaire && <h1>{config.questionnaire.title}</h1>}
      </div>
      {config.stepper && (
        <div className="stepper-quizz">{state.started && <Stepper />}</div>
      )}
      <div className="body-quizz" style={{ minHeight: heightQuizz }}>
        <TransitionGroup component={null}>
          {config.questionnaire && !state.completed && isLoaded && (
            <CSSTransition classNames="loader" timeout={300}>
              <Quizz />
            </CSSTransition>
          )}
        </TransitionGroup>
        {!isLoaded && (
          <div className="pre-loader">
            <div className="pre-loader-msg" css={css({ color: "muted" })}>
              Chargement...
            </div>
          </div>
        )}
      </div>
      <div className="quizz-viewer">
        {state.completed && state.results && state.results.length && (
          <QuizzViewer
            mainComponent={config.defaultViz}
            propsMainComponent={{
              // textColorUseScore: false,
              textColor: "#fff",
              valueTextFontSize: "32px",
              paddingVertical: 16,
            }}
            propsChildsComponent={{
              // textColorUseScore: false,
              // textColor: "#eee",
              valueTextFontSize: "18px",
              paddingVertical: 8,
            }}
          />
        )}
      </div>
    </>
  )
}

export default QuizzLoader
